/* eslint-disable no-console */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
// import '@/misc/handle-network-status';
//import '@/misc/handle-apple-install-prompt';
import "./firebase/init"; // run first to init firebase
import "./firebase/authentication";
import "@/assets/app.css";
import "pwacompat";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./vee-validate";

import draggable from "vuedraggable";

Vue.use(draggable);

//import Vue2TouchEvents from 'vue2-touch-events';

//Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");

console.log(`
🍱 This app was bootstrapped with vuejs 🍱
👉 http://routine.oyen.de/
`);